import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import moment from 'moment';
import { WorkersAppealService, WorkersAppealServiceData } from "../../services/workersAppealKpi/workersAppeal.service";
import { DualSummaryDetailKpiServiceHost } from "src/app/dashboardCommon/components/kpiServiceHostComponent";
import { WorkersAppealDetailService, WorkersAppealDetailServiceData } from "../../services/workersAppealKpi/workersAppealDetail.service";
import { LoggerService } from "src/app/common/logging/logger.service";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";
import { OfficeSelectorService } from "src/app/common/officeSelector/officeSelector.service";
import { WorkersAppealKpiCfg, WorkersAppealKpiCfgService } from "../../services/workersAppealKpi/workersAppealKpiCfg.service";
import { ModalDialogComponent } from "src/app/common/modal/modalDialog.component";
import { CellStyle, ColumnDefinition, DateColumnDefinition, EmailColumnDefinition, LinkColumnData, LinkColumnDefinition, PhoneNumberColumnDefinition, RowStyle, TextColumnDefinition } from "src/app/dashboardCommon/components/cardDetails/datatable.component";

export class WorkersAppealData {
    public consultant: number;
    public office: number;

    constructor(consultant: number, office: number) {
        this.consultant = consultant;
        this.office = office;
    }
}

export class WorkersAppealDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];
    public rowStyleSelector: (x) => RowStyle;

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;

        this.rowStyleSelector = (x) => {
            var style = new RowStyle();

            style.cellStyle = [
                new CellStyle("red", "white", 1),
                new CellStyle("red", "white", 3)
            ];

            return style;
        };
    }
}

@Component({
    selector: 'workers-appeal-pending-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class WorkersAppealPendingKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<WorkersAppealService, WorkersAppealServiceData, WorkersAppealData, WorkersAppealDetailService, WorkersAppealDetailServiceData, WorkersAppealDetailData>
    implements OnDestroy {

    public getClassName() { return "WorkersAppealPendingKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;
    @Input() public messageDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService, summaryService: WorkersAppealService, detailService: WorkersAppealDetailService, private serviceCfg: WorkersAppealKpiCfgService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: WorkersAppealServiceData, updateRequested: boolean): WorkersAppealData {
        return new WorkersAppealData(data.consultant, data.office);
    }

    protected getDefaultSummaryData(): WorkersAppealData {
        let data = new WorkersAppealData(0, 0);
        return data;
    }

    protected extractUpdateTime(data: WorkersAppealServiceData): Date {
        return data.updateTimestamp;
    }
    protected processDetailData(data: WorkersAppealDetailServiceData, args: any): WorkersAppealDetailData {
        if (data.workersAppeals) {
            let columnDefinitions = [
                new TextColumnDefinition("P. \nsolicitado", null, false),
                new LinkColumnDefinition("Total peticiones", null, false),
                new DateColumnDefinition("Fecha incorporación", (data) => {
                    let date = moment(data).startOf("day");
                    return date.format("DD/MM/YYYY");
                }, false),
                new TextColumnDefinition("Llamamientos", null, false),
                new TextColumnDefinition("Trabajador", null, false),
                new DateColumnDefinition("Fecha inicio llamamiento", null, false),
                new DateColumnDefinition("Fecha expiracion", null, false),
                new PhoneNumberColumnDefinition("Teléfono"),
                new EmailColumnDefinition("Email"),
                new TextColumnDefinition("Cliente", null, false),
            ];

            let cfg: WorkersAppealKpiCfg = this.serviceCfg.getCfg();

            let urlAppeal = cfg.urlAppeal;

            if (args && args.filter && args.filter.consultant) {

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                let tabledata = [];

                for (let workerAppeal of data.workersAppeals) {
                    if (workerAppeal.nif.toUpperCase() == consultantNif) {
                        tabledata.push([
                            workerAppeal.requestedJob,
                            new LinkColumnData(workerAppeal.totOrders.toString(), `${urlAppeal}${workerAppeal.orderId}`),
                            workerAppeal.ctoBegDate,
                            workerAppeal.totWorkerCallStatusId.toString() + ' pdtes',
                            workerAppeal.allName,
                            workerAppeal.currentCallDate ? new Date(workerAppeal.currentCallDate.toString()).toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute: '2-digit' }) : '',
                            workerAppeal.expireDate ? new Date(workerAppeal.expireDate.toString()).toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute: '2-digit' }) : '',
                            workerAppeal.mobilePhone,
                            workerAppeal.email,
                            workerAppeal.clienteName
                        ]);
                    }
                }

                return new WorkersAppealDetailData(columnDefinitions, tabledata);
            } else {
                let tabledata = [];
                (data.workersAppeals || [])
                    .forEach(w =>
                        tabledata.push([
                            w.requestedJob,
                            new LinkColumnData(w.totOrders.toString(), `${urlAppeal}${w.orderId}`),
                            w.ctoBegDate,
                            w.totWorkerCallStatusId.toString() + ' pdtes',
                            w.allName,
                            w.currentCallDate ? new Date(w.currentCallDate.toString()).toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute: '2-digit' }) : '',
                            w.expireDate ? new Date(w.expireDate.toString()).toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute: '2-digit' }) : '',
                            w.mobilePhone,
                            w.email,
                            w.clienteName
                        ]));

                return new WorkersAppealDetailData(columnDefinitions, tabledata);
            }
        }
        else return this.getDefaultDetailData();
    }

    protected getDefaultDetailData(): WorkersAppealDetailData {
        let columnDefinitions = [
            new TextColumnDefinition("Puesto", null, false),
            new LinkColumnDefinition("Total peticiones", null, false),
            new DateColumnDefinition("Fecha incorporación", (data) => {
                let date = moment(data.date).startOf("day");
                if (date.isSame(moment(new Date("0001-01-01T00:00:00")))) {
                    return data.status;
                } else {
                    if (date.isValid()) return date.format("DD/MM/YYYY");
                    else return data.status;
                }
            }, false),
            new TextColumnDefinition("Llamamientos", null, false),
            new TextColumnDefinition("Trabajador", null, false),
            new TextColumnDefinition("Fecha inicio llamamiento", null, false),
            new DateColumnDefinition("Fecha expiracion", null, false),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new TextColumnDefinition("Cliente", null, false),
        ];

        return new WorkersAppealDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }
}
